import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getBudgetItem(params) {
  return request({
    url: '/bsProjectBudget',
    method: 'get',
    params: params
  })
}
/**
 * 添加
 * @param {*} params
 */
export function addProjectBudget(params) {
  return request({
    url: '/bsProjectBudget/save',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 */
export function editProjectBudget(params) {
  return request({
    url: '/bsProjectBudget/update',
    method: 'put',
    data: params
  })
}
/**
 * 通过id删除
 */
export function deleteProjectBudget(id) {
  return request({
    url: `/bsProjectBudget/${id}`,
    method: 'delete',
  })
}
/**
 * 查看详情
 */
export function getProjectBudgetInfo(id) {
  return request({
    url: `/bsProjectBudget/${id}`,
    method: 'get'
  })
}
